import { CobaltTag } from '@cae/cobalt-react/components/tag';
import { CobaltClickableTile } from '@cae/cobalt-react/components/tile';
import { CobaltIconCautionMajorSolid } from '@cae/cobalt-react/icons/solid/CobaltIconCautionMajorSolid';
import { CobaltIconWarningMajorSolid } from '@cae/cobalt-react/icons/solid/CobaltIconWarningMajorSolid';
import * as React from 'react';

import type { InvoiceAlertTileProps } from './InvoiceAlertTile.types';

import styles from './InvoiceAlertTile.module.css';

const InvoiceAlertTile = React.memo(
  ({
    amount,
    currency,
    priorityType,
    invoiceCount,
    onClick,
  }: Readonly<InvoiceAlertTileProps>): React.ReactElement => {
    const isPastDue = priorityType === 'PastDue';
    return (
      <CobaltClickableTile
        id={`alert-tile-${priorityType}-${currency}`}
        className={styles.invoiceAlertTile}
        data-testid="invoices-alerts-tile"
        onClick={onClick}
      >
        <CobaltTag
          color={isPastDue ? 'critical-warning' : 'warning'}
          className={
            isPastDue
              ? styles.invoiceAlertTileTagPastDue
              : styles.invoiceAlertTileTag
          }
        />
        <div className={styles.invoiceAlertTileTextContent}>
          <div className={styles.invoiceAlertTileHeader}>
            <div className={styles.amountCurrencyWrapper}>
              <p
                className={`heading-06 ${styles.invoiceAlertTileCount}`}
                data-testid="alert-amount"
              >
                {amount}
              </p>
              <span className={`heading-01 ${styles.currency}`}>
                {currency}
              </span>
            </div>

            <div className={styles.invoiceAlertTileIconRow}>
              {isPastDue ? (
                <CobaltIconWarningMajorSolid
                  size="medium"
                  className={styles.iconPastDue}
                  aria-label="Past due"
                />
              ) : (
                <CobaltIconCautionMajorSolid
                  size="medium"
                  className={styles.iconDueSoon}
                  aria-label="Due in the next 7 days"
                />
              )}
            </div>
          </div>
          <p
            className={styles.invoiceAlertTileDescription}
            data-testid="action-tile-description"
          >
            <span className={styles.textRow}>
              <span className="body-01">
                {isPastDue
                  ? 'In past due invoices'
                  : 'In invoices due in the next 7 days'}
              </span>
              <span className={`body-01 ${styles.invoiceCount}`}>
                ({invoiceCount} {invoiceCount === 1 ? 'invoice' : 'invoices'})
              </span>
            </span>
          </p>
        </div>
      </CobaltClickableTile>
    );
  }
);

InvoiceAlertTile.displayName = 'InvoiceAlertTile';
export { InvoiceAlertTile };
